import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/models/page';
import { WebshopsPageContent } from '@/pages/standardShops/components/WebshopsPageContent';

const WebshopsPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Webshops | Starjack Admin</Helmet>

            <WebshopsPageContent />
        </>
    );
};

WebshopsPage.isProtected = true;
WebshopsPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default WebshopsPage;
